// Descontinuação deste portal (React) em favor do novo portal (Angular).
// Data e endereço ficam só aqui; o aviso (~/componentes/AvisoNovoPortal) lê destas constantes.
export const novoPortalUrl = 'https://homolog.projetos.erpworks.com.br';

// AAAA-MM-DD, contada no fuso do navegador.
export const dataDescontinuacao = '2026-12-31';
